module.exports = __webpack_public_path__ + "static/media/34.71b73f60.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/34.jpg
// module id = 294
// module chunks = 0